// 工事検索
export const periodProp = {
  type: 'number',
  label: '',
  name: 'period',
  value: '',
  rules: 'numeric|max: 2'
};
export const constructionIdProp = {
  type: 'number',
  label: '',
  name: 'constructionId',
  value: '',
  rules: 'numeric|max: 3'
};
export const subjectProps = {
  label: '',
  name: 'subject',
  disabled: false,
  options: [
    { value: 1, text: '1(建築)' },
    { value: 2, text: '2(土木工事/線路)' },
    { value: 3, text: '3(土木工事/一般)' }
  ]
};

export interface Data {
  construction_management_no: string;
  i_id: string;
  fiscalYear: string;
  constructionId: string;
  constructionName: string;
  primeContractorName: string;
  divition: string;
}

export const DetailNotFoundMessage = '請求書データがありません';